import survey_dashboard from "../../Assets/Images/survey_dashboard.png";
import tank from "../../Assets/Images/tank.jpg";
import dashboard_hero from "../../Assets/Images/dashboard_hero.png";
import NewsSlider from "../../Components/Home/NewsSlider";
import FAQ from "../../Components/Home/FAQ.js";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Building2, ClipboardList } from "lucide-react";

const Home = () => {
  const { t } = useTranslation();

  return (
    <div className=" w-full h-full  text-[#2F4B7C] bangla-font">
      <div className="relative w-full">
        <div className="flex flex-col large:flex-row items-center gap-8 large:gap-4 px-[5%] py-8">
          <div className="w-[70%] sm:w-[55%] large:w-1/2 flex justify-center">
            <img
              src={dashboard_hero}
              alt="National Sanitation Dashboard"
              className="w-full max-w-xl"
            />
          </div>

          <div className="w-full large:w-1/2 text-center large:text-right">
            <h2 className="text-[28px] sm:text-[34px] lg:text-[40px] font-bold leading-tight">
              {t(`new_home.title`)}
            </h2>
            <p className="mt-3 text-[14px] sm:text-[16px] lg:text-[18px] leading-6 lg:leading-7 large:ml-auto large:max-w-xl">
              {t("new_home.subtitle")}
            </p>

            <div className="mt-6">
              <Link to="/city-profile">
                <button className="bg-[#2F4B7C] text-white text-[14px] sm:text-[16px] font-semibold px-5 py-3 rounded-md hover:bg-[#25406b] transition-colors">
                  {t("new_home.visit_national_sanitation_dashboard")}
                </button>
              </Link>
            </div>

            <div className="mt-6 flex flex-wrap justify-center large:justify-end gap-4">
              <div className="bg-[#2F4B7C] text-white rounded-md px-5 py-3 flex items-center gap-3 min-w-[180px]">
                <Building2 className="shrink-0" size={22} />
                <div className="text-left">
                  <p className="text-[18px] font-bold leading-none">
                    {t("new_home.municipalities_count")}
                  </p>
                  <p className="text-[12px] leading-tight">
                    {t("new_home.municipalities")}
                  </p>
                </div>
              </div>

              <div className="bg-[#2F4B7C] text-white rounded-md px-5 py-3 flex items-center gap-3 min-w-[180px]">
                <ClipboardList className="shrink-0" size={22} />
                <div className="text-left">
                  <p className="text-[18px] font-bold leading-none">
                    {t("new_home.surveys_count")}
                  </p>
                  <p className="text-[12px] leading-tight">
                    {t("new_home.surveys")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 lg:pt-0 bottom-28 left-0  w-full">
          <img className="w-full " src="/images/bg-colored.svg" alt="background-art" />
        </div>
      </div>

      <div className=" w-full mt-8 ">
        <div className="text-[#2F4B7C] text-center w-full space-y-4">
          <div className="">
            <h2 className="px-[15%]  tablet:px-[18%] large:px-[25%] text-[26px] tablet:text-[30px] large:text-[36px] font-bold ">
              {t("new_home.city_profile_and_city_comparison")}
            </h2>
            <p className="px-[10%] md:px-[25%] lg:px-[20%] pb-4 text-[15px] tablet:text-[18px] large:text-[24px] ">
              {t("new_home.city_profile_and_city_comparison_sub")}
            </p>
          </div>

          <div className="relative ">
            <img
              src="/images/dashboard.svg"
              alt="dashboard"
              className="w-[75%] mx-auto max-w-6xl"
            />
          </div>
        </div>
      </div>

      <div className="w-full mt-8">
        <img
          src="/images/vacutag.svg"
          alt=""
          className="invisible w-1/2 ml-auto translate-y-2 -z-50 max-w-2xl 2xl:ml-[50%]"
        />
        <div className="max-w-3xl bg-[#2F4B7C] text-white w-[75%] mx-auto space-y-4 z-10 relative large:flex gap-6 h-[100%]">
          <img
            src="/images/charts.svg"
            alt=""
            className="-translate-y-2 large:w-[60%] large:absolute left-0 -top-36"
          />
          <div className="text-[20px] font-bold pb-8 large:text-left large:ml-auto large:mr-[10%]">
            <p>{t("new_home.sankey_diagram")}</p>
            <p>{t("new_home.sunburst_diagram")}</p>
            <p>
              <span className="font-normal mr-2">{t("new_home.and")}</span>
              {t("new_home.shit_flow_diagram")}
            </p>
            <p className="text-[15px]">
              
              {t("new_home.to_dive_deeper_into_the_insights")}
            </p>
          </div>
        </div>
      </div>

      <div className=" w-full mt-20">
        <div>
          <h2 className="px-[15%]  tablet:px-[18%] large:px-[25%] text-[26px] tablet:text-[30px] large:text-[36px] font-bold">
            {t("new_home.Key_indicators_analysis")}
          </h2>
          <p className="px-[10%] md:px-[25%] lg:px-[20%] pb-4 text-[15px] tablet:text-[18px] large:text-[24px] ">
            {t("new_home.Key_indicators_analysis_sub")}
          </p>
        </div>
        <div className="relative">
          <img
            src="/images/indicators.svg"
            alt="indicators"
            className="w-[75%] mx-auto max-w-6xl bg-white"
          />
          <img
            src="/images/sit_dump.svg"
            alt="pooping and sitting"
            className="invisible absolute right-0 top-[75%] w-[20%] -z-10"
          />
        </div>
      </div>

      <div className="w-full mt-20">
        <div>
          <h2 className="px-[15%]  tablet:px-[18%] large:px-[25%] text-[26px] tablet:text-[30px] large:text-[36px] font-bold">
            {t("new_home.survey_management_and_monitoring")}
          </h2>
          <p className="px-[10%] md:px-[25%] lg:px-[20%] pb-4 text-[15px] tablet:text-[18px] large:text-[24px] ">
            {t("new_home.survey_management_and_monitoring_sub")}
          </p>
        </div>
        <div className="relative">
          <img
            src={survey_dashboard}
            alt="dashboard 2"
            className="w-[75%] mx-auto max-w-6xl bg-white"
          />
        </div>
      </div>
      <div className="relative w-full mt-20">
        <img
          src={tank}
          alt=""
          className="invisible -z-10 absolute w-[38%] tablet:w-[35%] large:w-[32%] -left-6 tablet:-left-10 -top-20 tablet:-top-28 max-w-2xl"
        />
        <div>
          <h2 className="px-[15%]  tablet:px-[18%] large:px-[25%] text-[26px] tablet:text-[30px] large:text-[36px] font-bold">
            {t("new_home.create_manage_and_monitor_kii")}
          </h2>
          <p className="px-[10%] md:px-[25%] lg:px-[20%] pb-4 text-[15px] tablet:text-[18px] large:text-[24px] ">
            {t("new_home.create_manage_and_monitor_kii_sub")}
          </p>
        </div>
        <div className="relative">
          <img
            src="/images/data_collection_kii.svg"
            alt="data collection dashboard KII"
            className="w-[75%] mx-auto max-w-6xl bg-white"
          />
        </div>
      </div>

      <div className="w-full mt-20">
        <h2 className="px-[15%]  tablet:px-[18%] large:px-[25%] text-[26px] tablet:text-[30px] large:text-[36px] font-bold">
          {t("new_home.integrated_with_sub_national_and_national_platforms")}
        </h2>
        <img
          src="/images/imislogo.svg"
          className="mx-auto w-[55%] tablet:w-[35%] large:w-[30%]  py-8"
          alt=""
        />
        <h2 className="px-[15%]  tablet:px-[18%] large:px-[25%] text-[26px] tablet:text-[30px] large:text-[36px] font-bold">
          {t("new_home.imis")}
        </h2>
        <p className="text-[14px] sm:text-[16px] md:text-[18px] lg:text-[20px] font-light opacity-65 w-[70%] tablet:w-[60%] large:w-[50%] mx-auto">
          {t("new_home.imis_sub")}
        </p>
      </div>

      <FAQ />

      <NewsSlider />
    </div>
  );
};

export default Home;
